import { render, staticRenderFns } from "./ThirdPartyServiceActiveToggleButton.vue?vue&type=template&id=a95916be"
import script from "./ThirdPartyServiceActiveToggleButton.vue?vue&type=script&lang=js"
export * from "./ThirdPartyServiceActiveToggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports